import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import './style.css'; // Ensure you import your CSS file

export interface FileWithPreview extends File {
    preview: string;
    nome: string;
}

interface DropzoneComponentProps {
    files: FileWithPreview[];
    onFileChange: (newFiles: FileWithPreview[]) => void;
}

const DropzoneEmpresaComponent: React.FC<DropzoneComponentProps> = ({ files, onFileChange }) => {
    const [localFiles, setLocalFiles] = useState<FileWithPreview[]>(files ? files : []);

    const onDrop = (acceptedFiles: File[]) => {
        const filesWithPreview = acceptedFiles.map(file => ({
            ...file,
            preview: URL.createObjectURL(file),
            name: file.name
        }));
        const newFiles: any = [...localFiles, ...filesWithPreview];
        setLocalFiles(newFiles);
        onFileChange(newFiles);
    };
    
    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    const removeFile = (fileToRemove: FileWithPreview) => {
        const remainingFiles = localFiles.filter(file => file !== fileToRemove);
        setLocalFiles(remainingFiles);
        onFileChange(remainingFiles);
    };

    useEffect(() => {
        // Limpar a URL dos previews quando o componente é desmontado
        return () => {
            localFiles.forEach(file => URL.revokeObjectURL(file.preview));
        };
    }, []);

    return (
        <div className='dropzone-body'>
            <div className='dropzone-container'>
                <div {...getRootProps()} className="dropzone">
                    <input {...getInputProps()} />
                    {
                        <div className='dropzone-container-text'>
                            <p><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" fillRule="evenodd" stroke="#007bff" strokeWidth="2"><circle cx="16" cy="16" r="15"></circle><path stroke-linecap="square" d="M16.062 10.378L16.062 22.325M21.473 16.432L10.354 16.432"></path></g></svg></p>
                            <p className='dz-cont-text-title'>Anexe ou arraste o documento aqui</p>
                            <p className='dz-cont-text-subtitle'>Até 50 MB por arquivo em .jpg, .jpeg, .png, .txt ou .pdf.</p>
                        </div>
                    }
                </div>
                <aside>
                    {localFiles.map((file, index) => (
                        <div key={index} className="file-details">
                            <span className="file-name">{file.name}</span>
                            <button onClick={() => removeFile(file)} className="remove-button">Remover</button>
                        </div>
                    ))}
                </aside>
            </div>
        </div>
    );
}

export default DropzoneEmpresaComponent;
